// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap"
import "chartkick/chart.js"
import NewRealizedPresetNodeImageEffect from './new_realized_preset_node_image_effect.js'
import NewRealizedPresetColorLoader from './new_realized_preset_color_loader.js'
import RealizedPresetRandomizer from './realized_preset_randomizer.js'

//! TODO: FIX OR DELETE
// // dynamically set active navbar link
// function set_nav_active() {
// 	document.querySelectorAll('.navbar-nav .nav-link.active').forEach((x) => {
// 		x.classList.remove('active');
// 		console.log(x);
// 	});

// 	console.log("identified current nav: ", document.querySelector(`.nav-link[href="${window.location.pathname}"]`));
// 	document.querySelector(`.nav-link[href="${window.location.pathname}"]`).classList.add('active');
// }

// window.addEventListener('load', () => { console.log('window load sets nav'); set_nav_active(); });
// document.addEventListener('turbo:load', () => { console.log('turbolinks sets nav'); set_nav_active(); });

// Handle confirmation dialogs for buttons with data-confirm
function setupConfirmationDialogs() {
	document.querySelectorAll('button[data-confirm]').forEach(button => {
		button.addEventListener('click', function(e) {
			e.preventDefault();
			
			const confirmMessage = this.dataset.confirm;
			const form = this.closest('form');
			
			// Create Bootstrap modal
			const modalHtml = `
				<div class="modal fade" id="confirmModal" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
					<div class="modal-dialog">
						<div class="modal-content">
							<div class="modal-header">
								<h5 class="modal-title" id="confirmModalLabel">Confirm Action</h5>
								<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
							</div>
							<div class="modal-body">
								${confirmMessage}
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
								<button type="button" class="btn btn-danger" id="confirmAction">Confirm</button>
							</div>
						</div>
					</div>
				</div>
			`;
			
			// Remove existing modal if any
			const existingModal = document.getElementById('confirmModal');
			if (existingModal) {
				existingModal.remove();
			}
			
			// Add modal to body
			document.body.insertAdjacentHTML('beforeend', modalHtml);
			
			// Show modal
			const modal = new bootstrap.Modal(document.getElementById('confirmModal'));
			modal.show();
			
			// Handle confirm button click
			document.getElementById('confirmAction').addEventListener('click', function() {
				modal.hide();
				if (form) {
					form.submit();
				}
			});
			
			// Clean up modal after it's hidden
			document.getElementById('confirmModal').addEventListener('hidden.bs.modal', function() {
				this.remove();
			});
		});
	});
}

// Bootstrap form validation
function setupFormValidation() {
	document.querySelectorAll('.needs-validation').forEach(form => {
		form.addEventListener('submit', function(event) {
			if (!form.checkValidity()) {
				event.preventDefault();
				event.stopPropagation();
			}
			form.classList.add('was-validated');
		}, false);
	});
}

// Setup confirmation dialogs on page load
window.addEventListener('load', setupConfirmationDialogs);
document.addEventListener('turbo:load', setupConfirmationDialogs);

// Setup form validation on page load
window.addEventListener('load', setupFormValidation);
document.addEventListener('turbo:load', setupFormValidation);

// Callback so an order summary widget can trigger order creation
function addOrderFormTrigger() {
	const orderFormTrigger = document.querySelector('#order_form_trigger');

	if (orderFormTrigger) {
		orderFormTrigger.addEventListener('click', (e) => {
				e.preventDefault();
				document.querySelector("form#new_order").submit();
		});
	}
}

window.addEventListener('load', addOrderFormTrigger);
document.addEventListener('turbo:load', addOrderFormTrigger);

// Initialize realized preset image effects
function initializeRealizedPresetImageEffects() {
	if (document.querySelector('.js-preset-node-container')) {
		new NewRealizedPresetNodeImageEffect();
	}
}

// Initialize realized preset color loader
function initializeRealizedPresetColorLoader() {
	if (document.querySelector('.js-preset-node-container[data-node-type="designation"]')) {
		new NewRealizedPresetColorLoader();
	}
}

window.addEventListener('load', initializeRealizedPresetImageEffects);
document.addEventListener('turbo:load', initializeRealizedPresetImageEffects);

window.addEventListener('load', initializeRealizedPresetColorLoader);
document.addEventListener('turbo:load', initializeRealizedPresetColorLoader);

// Initialize realized preset randomizer
function initializeRealizedPresetRandomizer() {
	if (document.querySelector('#realizedPresetForm')) {
		new RealizedPresetRandomizer();
	}
}

window.addEventListener('load', initializeRealizedPresetRandomizer);
document.addEventListener('turbo:load', initializeRealizedPresetRandomizer);
